import React, { useEffect, useState } from 'react'
import InformationBandeau from '../../../generic/information-bandeau/information-bandeau'
import { useSelector } from 'react-redux'
import { ApplicationState } from '../../../../store'
import { AuthenticationState } from '../../../../model/state/authentication-state'
import { NaturalUserScaInformationResponse, ProfilCode } from '../../../../model/dto/response'
import './sca-information-bandeau.css'
import { Icon } from 'semantic-ui-react'
import { SimpleButton } from '../../../generic/simple-button'
import { useLocation, useNavigate } from 'react-router-dom'
import { trackPromise } from 'react-promise-tracker'
import { userService } from '../../../../services/authentication-redux-service'
import { StatutSca } from '../../../../model/entities/statut-sca'


export default function ScaInformationBandeau() {
    const loginProps: AuthenticationState = useSelector<ApplicationState, AuthenticationState>(state => state.authentication)
    const location = useLocation()
    const navigate = useNavigate()
    const [open, setOpen] = useState<boolean>(false)
    const [userScaInfo, setUserScaInfo] = useState<NaturalUserScaInformationResponse>()
    const isShowStatutCode = (statutCode: string | null) => {
        if(statutCode === null || statutCode === undefined){
            return true
        }
        else {
            if(statutCode === StatutSca.VALIDE || statutCode === StatutSca.VALIDATION_EN_ATTENTE){
                return false
            }
            return true
        }
    }
    
    useEffect(()=> {
        if(loginProps?.isAuthenticated){
            trackPromise(userService.getNaturalUserScaInformation(loginProps?.oauth?.userId, loginProps?.oauth)
                .then(response => {
                setUserScaInfo(response)
            }))
        }
    },[location])

    const showScaInfoBandeau = loginProps?.user?.ProfilCode === ProfilCode.INVESTISSEUR && loginProps?.user?.Etablissement === null && isShowStatutCode(userScaInfo?.StatutScaCode!)

    const scaMessage = "À partir du 1er Juillet 2025, Villyz et son prestataire de paiement renforcent la sécurité des comptes et leur politique anti-fraude. Afin de continuer à utiliser les services de Villyz, vous devez configurer votre authentification forte. Pour cela, rien de plus simple : rendez vous sur votre page profil où vous serez invité à saisir votre numéro de téléphone et à le valider grâce à la réception d'un mot de passe unique par SMS."

    const informationLabelMessage = <p className='mobile-sca-info-preview-message'><Icon name="info circle" color='blue' size='large'/> Information importante sur votre compte !</p>

    const toggleOpenAction = () => setOpen(!open)
  return (
    <div className={showScaInfoBandeau ? "show-bandeau" : "hide-bandeau"}>
        {/* <Container> */}
        <div className='desktop-sca-info-container'>
            <InformationBandeau 
                message={scaMessage}
                type="information-no-border"
                icon={{
                    name: "info circle",
                    color: 'blue',
                    size:'large'
                }}
            >
                <SimpleButton 
                label='Accéder à mon profil'
                onClick={() => navigate('/profil')}
                secondary
                />
            </InformationBandeau>
        </div>
        {/* </Container> */}
        <div className='mobile-sca-info-container information-no-border'>
           {open ? <InformationBandeau 
                message={scaMessage}
                type="information-no-border"
                icon={{
                    name: "info circle",
                    color: 'blue',
                    size:'large'
                }}
            >
                <SimpleButton 
                label='Accéder à mon profil'
                onClick={() => navigate('/profil')}
                secondary
                />
            </InformationBandeau> 
            : informationLabelMessage
            }
            <button aria-label="bouton d'ouverture ou fermeture du bandeau déroulant" onClick={toggleOpenAction} className='mobile-sca-info-button information-no-border' aria-roledescription='button'><Icon name={open ?'angle up' : 'angle down'} size='large'/></button>
        </div>
    </div>
  )
}
